import { ref } from 'vue';
import { createWxCodePayOrder, getStatus } from '@/request/equity';

interface PaymentParams {
  amount: number;
  businessId?: string;
  businessType: string;
  [key: string]: any;
}

interface OrderStatusCallback {
  onSuccess?: () => void;
  onFailed?: (error: any) => void;
  onPending?: () => void;
}

export default function usePayment() {
  const orderStatusTimer = ref<any>(null);
  const currentOrder = ref<any>(null);

  // 创建订单
  const createOrder = async (params: PaymentParams) => {
    try {
      const response = await createWxCodePayOrder(params);
      const { code, data } = response.data;

      if (code === 200) {
        currentOrder.value = data;
        return data;
      }
      throw new Error('创建订单失败');
    } catch (error) {
      console.error('创建订单错误:', error);
      throw error;
    }
  };

  // 监听支付状态
  const watchOrderStatus = async (orderPaymentId: string, callbacks?: OrderStatusCallback) => {
    return new Promise((resolve, reject) => {
      const checkStatus = async () => {
        try {
          const res = await getStatus({ orderPaymentId });
          const { code, data: status } = res.data;

          if (code !== 200) {
            callbacks?.onFailed?.(new Error('查询订单状态失败'));
            reject(new Error('查询订单状态失败'));
            return;
          }

          switch (status) {
            case '待付款':
              callbacks?.onPending?.();
              orderStatusTimer.value = setTimeout(checkStatus, 1000);
              break;
            case '已完成':
              callbacks?.onSuccess?.();
              clearTimeout(orderStatusTimer.value!);
              resolve(status);
              break;
            default:
              clearTimeout(orderStatusTimer.value!);
              resolve(status);
          }
        } catch (error) {
          callbacks?.onFailed?.(error);
          reject(error);
        }
      };
      checkStatus();
    });
  };

  // 清理定时器
  const clearTimer = () => {
    if (orderStatusTimer.value) {
      clearTimeout(orderStatusTimer.value);
      orderStatusTimer.value = null;
    }
  };

  // 关闭支付弹窗
  const closePayment = () => {
    clearTimer();
  };

  return {
    currentOrder,
    createOrder,
    watchOrderStatus,
    closePayment,
  };
}
